import { render, staticRenderFns } from "./PesquisaAvaliacaoSono.vue?vue&type=template&id=1fd2d56a&scoped=true"
import script from "./PesquisaAvaliacaoSono.vue?vue&type=script&lang=js"
export * from "./PesquisaAvaliacaoSono.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAvaliacaoSono.vue?vue&type=style&index=0&id=1fd2d56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2d56a",
  null
  
)

export default component.exports